import type { RouteObject } from "react-router-dom";
import Layout from "../components/feature/Layout";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Quiz from "../pages/quiz/page";
import QuizResults from "../pages/quiz-results/page";
import DecisionTree from "../pages/decision-tree/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";
import CorporateEnquiries from "../pages/corporate-enquiries/page";
import ThankYou from "../pages/thank-you/page";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/quiz", element: <Quiz /> },
      { path: "/quiz-results", element: <QuizResults /> },
      { path: "/decision-tree", element: <DecisionTree /> },
      { path: "/about", element: <About /> },
      { path: "/contact", element: <Contact /> },
      { path: "/corporate-enquiries", element: <CorporateEnquiries /> },
      { path: "/thank-you", element: <ThankYou /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;